import { fetchStorageFile } from 'hooks/StoreFiles';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import StyledGlobal from '../../PlanoAnual2025.styled';
import Item from 'antd/es/list/Item';
import Colors from 'enums/Colors';
import AdEbook, { AdEbookEnum } from 'pages/ebooks/components/AdEbook';
import { Image } from 'antd';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        background-color: #eae8e6;
        font-family: 'Barlow', sans-serif;
        padding-bottom: 80px;
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding-left: 20px;
    `,

    SubTitle: styled.h2`
        color: ${Colors.Blue};
        font-weight: bold;
        font-size: 18px;
    `,

    Item: styled.div`
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        h1 {
            font-size: 18px;
            font-weight: bold;
        }

        p {
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
        }
    `,
};

const ItemExpediente = (props: { title: string; value: string }) => {
    return (
        <Styled.Item>
            <h1>{props.title}</h1>
            <p dangerouslySetInnerHTML={{ __html: props.value }} />
        </Styled.Item>
    );
};

const ExpedientePlanoAnual: React.FC = () => {
    const [imgWidth, setImgWidth] = useState<string>('80%');
    const [adType, setAdType] = useState(AdEbookEnum.FULL);
    useEffect(() => {
        const update = () => {
            const w = window.innerWidth;
            if (w >= 1280) {
                setImgWidth('80%');
                setAdType(AdEbookEnum.FULL);
            } else if (w >= 768) {
                setImgWidth('90%');
                setAdType(AdEbookEnum.FULL);
            } else {
                setImgWidth('100%');
            }
        };

        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    return (
        <Styled.Container>
            <Image
                width={imgWidth}
                src={fetchStorageFile('anexo_storage_files_11578208499553592274.svg_2025-11-18-1763488222258.svg')}
                alt=""
                style={{ zIndex: 1, display: 'flex', alignSelf: 'center', justifySelf: 'center' }}
                preview={{
                    style: {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    },
                }}
            />

            <ResponsiveGrid
                templates={{
                    desktop: '2fr 1fr 1fr 1fr',
                    notebook: '2fr 1fr 1fr 1fr',
                    tablet: '1fr 1fr',
                    mobile: '1fr',
                }}
            >
                <Styled.Content>
                    <div
                        style={{
                            fontSize: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                        }}
                    >
                        <p>2025</p>
                        <p>© Instituto Ayrton Senna</p>
                    </div>
                    <AdEbook type={adType} styles={{ alignSelf: 'center' }} />
                </Styled.Content>
                <Styled.Content>
                    <StyledGlobal.Title blue fontSize="24px">
                        EXPEDIENTE
                    </StyledGlobal.Title>
                    <Styled.SubTitle>INSTITUTO AYRTON SENNA</Styled.SubTitle>
                    <ItemExpediente title="PRESIDENTE" value="Viviane Senna" />
                    <ItemExpediente title="VICE-PRESIDENTE" value="Ewerton Fulini" />
                    <ItemExpediente title="DIRETORA DE EDUCAÇÃO" value="Inês Kisil Miskalo" />
                    <ItemExpediente title="GERENTE DE CANAIS" value="Mariana Vitarelli" />
                    <ItemExpediente title="COORDENADOR DO PROJETO" value="Marcos Drummond" />
                </Styled.Content>
                <Styled.Content>
                    <div style={{ marginTop: '120px' }}>
                        <ItemExpediente
                            title="AGENTES TÉCNICAS"
                            value={`
                                Ana Paula De Souza Colling <br/>
                                Claudiana Tavares Freitas <br/>
                                Maria Adriana Guimaraes <br/>
                                Andrade da Silva <br/>
                                Ednalda Maria de Assis <br/>
                                Fabiana Gorete de Lima <br/>
                                Itacaramby <br/>
                                Luzinaide Mota Klen da Silva <br/>
                                Sandra Giovina Ponzio Ferreira
                                                            
                            `}
                        />
                    </div>
                </Styled.Content>
                <Styled.Content>
                    <div style={{ marginTop: '60px' }}>
                        <Styled.SubTitle>PUBLICAÇÃO</Styled.SubTitle>
                    </div>
                    <ItemExpediente
                        title="PRODUÇÃO"
                        value={`
                            Luan Paciencia <br/>
                            Gabriela Cáceres
                                                            
                            `}
                    />
                    <ItemExpediente
                        title="EDIÇÃO"
                        value={`
                            Gabriela Cáceres
                                                            
                            `}
                    />
                    <ItemExpediente
                        title="PROJETO GRÁFICO
                        E DIAGRAMAÇÃO"
                        value={`
                           Luan Paciencia
                                                            
                            `}
                    />
                    <ItemExpediente
                        title="ILUSTRAÇÕES"
                        value={`
                           Yasmin Dib
                                                            
                            `}
                    />
                </Styled.Content>
            </ResponsiveGrid>
        </Styled.Container>
    );
};

export default ExpedientePlanoAnual;
